import { createContext, useContext } from 'react';

/**
 * Mở dialog liên hệ. `null` là giá trị mặc định CỐ Ý — xem `useContactDialog`.
 */
export const ContactDialogContext = createContext<(() => void) | null>(null);

/**
 * Trả hàm mở dialog liên hệ.
 *
 * Ném khi không có provider thay vì trả no-op: một nút CTA im lặng không làm gì là lỗi KHÔNG
 * nhìn thấy được — nó chỉ lộ ra khi có người thật bấm và không báo cho ai. Ném thì nó vỡ ở test
 * và ở lượt render đầu tiên, tức lộ ra ở chỗ rẻ nhất.
 */
export function useContactDialog(): () => void {
  const open = useContext(ContactDialogContext);
  if (open === null) {
    throw new Error(
      'useContactDialog phải nằm trong <ContactDialogProvider> (RootLayout dựng nó).',
    );
  }
  return open;
}
